import BaseController from "niteroi/packages/system/controllers/Base.controller";

export default class Main extends BaseController {
    public onInit(): void {
        super.onInit();
    }

    public onBeforeRendering(): void {
        super.onBeforeRendering();
    }
}
